const initialState = {
  tags: [
    {
      Id: 1,
      Title: 'New',
    },
    {
      Id: 2,
      Title: 'Generic',
    },
    {
      Id: 3,
      Title: 'productivity',
    },
    {
      Id: 4,
      Title: 'collaboration',
    },
    {
      Id: 5,
      Title: 'informational',
    },
    {
      Id: 6,
      Title: 'informational',
    },
    {
      Id: 7,
      Title: 'assets',
    },
    {
      Id: 8,
      Title: 'status',
    },
    {
      Id: 9,
      Title: 'activity',
    },
    {
      Id: 10,
      Title: 'actions',
    },
    {
      Id: 11,
      Title: 'notifications',
    },
    {
      Id: 12,
      Title: 'fallback',
    },
    {
      Id: 13,
      Title: 'Some custom tag',
    },
  ],
};

export default function testReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
